<template>
    <div>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
		<v-container fill-height fluid>
            <v-row align="center" justify="center">
                <v-card class="px-15 py-15">
                    <v-card-title class="justify-center white--text mt-8">
                        <v-avatar size="176">
                            <img
                                alt="Animal"
                                src="/img/claf.jpg"
                            >
                        </v-avatar>
                    </v-card-title>
                    <v-card-text class=text-center>
                        <div class="black--text text-h5 text-center">Animal #{{ $route.params.animal_number }}</div>
                        <div class="black--text text-h3 text-center">Registration Successful</div>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                            width="200"
                            color="secondary2 white--text"
                            class="white--text"
                            :to="{ name: 'Animals'}"
                        >
                            Back to Animal List
                        </v-btn>
                        <v-btn
                            width="200"
                            color="primary"
                            :to="{ name: 'AddAnimal'}"
                        >
                            Add another Animal
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    created() {
        
    },
    data() {
       return {
           breadcrumbs: [
				{
					text: 'Dashboard',
					disabled: false,
					to: '/',
				},
				{
					text: 'Animals',
					to: {
						name: 'Animals'
					},
					exact: true 
				},
				{
					text: 'Add Animal',
					disabled: true,
				},
			],
       }
   }
}
</script>